import { useTranslation } from "@i18n";
import { useState } from "react";
import DetailsIcon from "@Assets/icons/svg/details.svg";
import VersionIcon from "@Assets/icons/svg/VersionsIcon.svg";
import BookCoinIcon from "@Assets/icons/svg/BookWithCoinIcon.svg";
import ForwardArrowIcon from "@Assets/icons/svg/ForwardArrow.svg";
import BackwardArrowIcon from "@Assets/icons/svg/BackwardArrow.svg";
import { convertDate } from "@Services/luxonHelper";
import SelectDropDown from "@CubeComponents/Mui_Form/SelectDropDown";
import { VersionContent } from "@Features/files";
import IconComponent from "@CubeComponents/icons";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import UserNameTagComponent from "@CubeComponents/html/UserNameTagComponent";
import Text from "@CubeComponents/html/Text/Text";

function CostDatabaseProperties(props: any) {
  const { t } = useTranslation();
  const [accordianState, setAccordianState] = useState({
    showDetail: true,
    showVersion: true,
  });

  const getUserAvatar = (id: any, avatar?: any) => {
    return <UserNameTagComponent showAvatarOnly={avatar} id={id} size="XXS" isCircle />;
  };

  function detailsHeader() {
    return (
      <div className="flex items-center gap-3.5 ps-3 font-bold text-[#192048]">
        <img src={DetailsIcon} />
        {t("Details")}
      </div>
    );
  }
  const items = [{ text: "Close", id: "close" }];

  const handleSelectedOption = (args: any) => {
    if (args.item.properties.id === "close") {
      props.setShowProperties(false);
    }
  };

  function costDatabaseDetails() {
    return (
      <div className="flex flex-col gap-5 ps-3 text-[#192048]">
        <table>
          <tr>
            <th className="flex pb-[1.375rem] pe-9 text-start text-sm font-medium text-[var(--text-light)] whitespace-nowrap">
              {t("Description")}
            </th>
            <th className="max-w-[12.5rem] overflow-hidden text-ellipsis whitespace-nowrap pb-[1.375rem] text-start text-sm font-bold text-[var(--primary-text)]">
              {props.costDatabaseDetails.description}
            </th>
          </tr>
          <tr>
            <th className="flex pb-[1.375rem] pe-9 text-start text-sm font-medium text-[var(--text-light)] whitespace-nowrap">
              {t("Currency")}
            </th>
            <th className="max-w-[12.5rem] overflow-hidden text-ellipsis whitespace-nowrap pb-[1.375rem] text-start text-sm font-bold text-[var(--primary-text)]">
              {props.costDatabaseDetails.currencyName}
            </th>
          </tr>
          <tr>
            <th className="flex pb-[1.375rem] pe-9 text-start text-sm font-medium text-[var(--text-light)] whitespace-nowrap">
              {t("Date Created")}
            </th>
            <th className="max-w-[12.5rem] overflow-hidden text-ellipsis whitespace-nowrap pb-[1.375rem] text-start text-sm font-bold text-[var(--primary-text)]">
              {convertDate(Number(props.costDatabaseDetails.createdDate), "dateForText")}
            </th>
          </tr>
          <tr>
            <th className="flex pb-[1.375rem] pe-9 text-start text-sm font-medium text-[var(--text-light)] whitespace-nowrap">
              {t("Created by")}
            </th>
            <th className="text-start font-normal">{getUserAvatar(props.costDatabaseDetails.createdById)}</th>
          </tr>
        </table>
      </div>
    );
  }

  function versionHeader() {
    return (
      <div className="flex items-center gap-3.5 ps-3 font-bold text-[#192048]">
        <img src={VersionIcon} />
        {t("Versions")}
      </div>
    );
  }

  function costDatabaseVersionsDetails() {
    return (
      <VersionContent enableCostdatabaseContent costDatabaseDetails={props.costDatabaseDetails} {...({} as any)} />
    );
  }

  const handleAccordionState = (type: any) => () => {
    setAccordianState((prev) => ({ ...prev, [type]: !prev[type] }));
  };

  function contentAccordion() {
    return (
      <>
        <div className="shadow-none border-0 border-y border-button_light">
          <Accordion expanded={accordianState.showDetail} onChange={handleAccordionState("showDetail")}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>{detailsHeader()}</AccordionSummary>
            <AccordionDetails>{costDatabaseDetails()}</AccordionDetails>
          </Accordion>
        </div>

        <div className="border-0 border-b border-button_light">
          <Accordion expanded={accordianState.showVersion} onChange={handleAccordionState("showVersion")}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>{versionHeader()}</AccordionSummary>
            <AccordionDetails>{costDatabaseVersionsDetails()}</AccordionDetails>
          </Accordion>
        </div>
      </>
    );
  }
  return (
    <div className="flex h-full w-[25rem] flex-col rounded-md border border-[#ecf3fe] bg-[var(--surface-white)] shadow-[0_0.25rem_0.625rem_0_rgba(0,0,0,0.12)]">
      <div className="flex flex-col gap-3 pb-[1.875rem] ps-7 pt-[1.875rem]">
        <div className="flex justify-between font-bold text-[#192048]">
          <div className="flex gap-3 items-center w-full overflow-auto">
            <img className="h-6" src={BookCoinIcon} />
            <Text>{props.costDatabaseDetails.name}</Text>
          </div>
          <div className="me-6 flex flex-row gap-2 items-center">
            <img
              className="h-5"
              src={BackwardArrowIcon}
              onClick={() => {
                props.openProperties({
                  index: props.index,
                  isForward: false,
                });
              }}
            />
            <img
              className="h-5"
              src={ForwardArrowIcon}
              onClick={() => {
                props.openProperties({ index: props.index, isForward: true });
              }}
            />
            <SelectDropDown
              select={(args) => handleSelectedOption(args)}
              items={items}
              cssClass="e-caret-hide border-0 bg-white p-0"
            >
              <IconComponent name="threedots" width="1.25rem" height="1.25rem" />
            </SelectDropDown>
          </div>
        </div>
        <div className="text-primary_text flex gap-2 items-center">
          {getUserAvatar(props.costDatabaseDetails.createdById)}
          <span>{t("created on")}</span>
          {convertDate(Number(props.costDatabaseDetails.createdDate), "dateForText")}
        </div>
        <div className="text-sm font-medium text-[#192048]">{t("Add Tags")}</div>
      </div>
      <div className="flex h-full justify-between">
        <div className="w-full">{contentAccordion()}</div>
        <div className="flex w-[4.375rem] flex-col items-center gap-6 border border-[#ecf3fe] pt-5 text-center">
          <img
            src={DetailsIcon}
            onClick={() => {
              setAccordianState((prev) => ({
                ...prev,
                showDetail: !prev.showDetail,
              }));
            }}
          />
          <img
            src={VersionIcon}
            onClick={() => {
              setAccordianState((prev) => ({
                ...prev,
                showVersion: !prev.showVersion,
              }));
            }}
          />
          {/* <img
              src={ActivityIcon}
              onClick={() => {
              setAccordianState('showActivity');
            }}
            /> */}
        </div>
      </div>
    </div>
  );
}

export default CostDatabaseProperties;
